module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/3.c68464b9.png";